import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { useListRoles } from 'src/features/roles/api/useListRoles';
import { UserFormSchemaValues } from 'src/features/users/utils/formSchema';
import { userMessages } from 'src/features/users/utils/messages';
import { useParking } from 'src/providers/ParkingProvider';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form, FormControl, FormControlStack, FormItem, FormLabel, FormMessage, FormField } from 'src/registry/ui/Form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';

type UserFormProps = {
    form: UseFormReturn<UserFormSchemaValues>;
    onSubmit: (values: UserFormSchemaValues) => void;
};

function UpdateUserForm({ onSubmit, form }: UserFormProps) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { data: roles } = useListRoles({ parkingId, config: { enabled: !!parkingId } });

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<UserFormSchemaValues>
                form={form}
                name="user_first_name"
                label={formatMessage(userMessages.firstName)}
            />
            <InputFormField<UserFormSchemaValues>
                form={form}
                name="user_last_name"
                label={formatMessage(userMessages.lastName)}
            />
            <FormField
                control={form.control}
                name="sp_role"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog">
                            <FormattedMessage {...userMessages.role} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Select onValueChange={field.onChange} value={field.value ?? ''}>
                                    <SelectTrigger className="w-full">
                                        <SelectValue placeholder={`${formatMessage(userMessages.role)}...`} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {roles?.results?.map((role) => (
                                            <SelectItem key={role.id} value={role.id}>
                                                {role.name}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
        </Form>
    );
}

export default UpdateUserForm;
